import React from 'react';
import { Card } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { Badge } from '@/components/ui/badge';
import PageHead from '@/components/PageHead';

export default function CGVPage() {
  return (
    <div data-testid="cgv-page">
      <PageHead title="Conditions générales de vente" description="CGV B2B ALOFI SA — Conditions de vente entre professionnels." />
      <section className="hero-bg noise-overlay relative">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
          <Badge variant="outline" className="tracking-[0.08em] uppercase text-[10px] bg-white/80">B2B</Badge>
          <h1 className="mt-3 font-heading text-3xl sm:text-5xl font-semibold tracking-tight">Conditions générales de vente</h1>
          <p className="mt-2 text-muted-foreground max-w-2xl">Conditions générales de vente applicables aux relations commerciales B2B entre ALOFI SA et ses clients professionnels.</p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-6">
        <Card className="rounded-2xl border-border p-7">
          <h2 className="font-heading text-xl font-semibold">1. Objet</h2>
          <Separator className="my-3" />
          <p className="text-sm leading-relaxed">Les présentes conditions générales s’appliquent à toute commande passée auprès d’ALOFI SA dans le cadre de relations commerciales entre professionnels (B2B). Elles prévalent sur toutes conditions d’achat sauf accord dérogatoire écrit.</p>
        </Card>
        <Card className="rounded-2xl border-border p-7">
          <h2 className="font-heading text-xl font-semibold">2. Devis et commandes</h2>
          <Separator className="my-3" />
          <p className="text-sm leading-relaxed">Les ventes ne sont parfaites qu’après acceptation expresse et écrite de la commande par ALOFI SA, sur la base d’un devis nominatif valide. Les devis sont valables 30 jours sauf mention contraire.</p>
        </Card>
        <Card className="rounded-2xl border-border p-7">
          <h2 className="font-heading text-xl font-semibold">3. Prix</h2>
          <Separator className="my-3" />
          <p className="text-sm leading-relaxed">Les prix sont établis en euros HT, départ entrepôt. La TVA et les frais de port sont en sus. Une tarification dégrressive selon volume peut être négociée contractuellement.</p>
        </Card>
        <Card className="rounded-2xl border-border p-7">
          <h2 className="font-heading text-xl font-semibold">4. Livraison</h2>
          <Separator className="my-3" />
          <p className="text-sm leading-relaxed">Les délais sont indicatifs. ALOFI SA met tout en œuvre pour les respecter ; tout retard ne saurait justifier l’annulation de la commande ou le versement de dommages-intérêts. Le transfert des risques s’opère dès la mise à disposition des marchandises.</p>
        </Card>
        <Card className="rounded-2xl border-border p-7">
          <h2 className="font-heading text-xl font-semibold">5. Paiement</h2>
          <Separator className="my-3" />
          <p className="text-sm leading-relaxed">Sauf accord particulier, les factures sont payables à 30 jours date de facture. Tout retard de paiement entraîne de plein droit l’application des pénalités prévues par l’article L. 441-10 du Code de commerce ainsi que l’indemnité forfaitaire pour frais de recouvrement (40 €).</p>
        </Card>
        <Card className="rounded-2xl border-border p-7">
          <h2 className="font-heading text-xl font-semibold">6. Réserve de propriété</h2>
          <Separator className="my-3" />
          <p className="text-sm leading-relaxed">ALOFI SA conserve la propriété des marchandises livrées jusqu’au paiement intégral du prix par l’acheteur, conformément aux dispositions de l’article L. 624-16 du Code de commerce.</p>
        </Card>
        <Card className="rounded-2xl border-border p-7">
          <h2 className="font-heading text-xl font-semibold">7. Garanties et responsabilité</h2>
          <Separator className="my-3" />
          <p className="text-sm leading-relaxed">Les marchandises bénéficient des garanties légales applicables. Les réclamations doivent être formulées par écrit dans un délai de 8 jours après livraison. La responsabilité d’ALOFI SA est strictement limitée au montant facturer.</p>
        </Card>
        <Card className="rounded-2xl border-border p-7">
          <h2 className="font-heading text-xl font-semibold">8. Loi applicable et juridiction</h2>
          <Separator className="my-3" />
          <p className="text-sm leading-relaxed">Les présentes CGV sont régies par le droit français. Tout litige relatif à leur interprétation ou à leur exécution relève de la compétence exclusive du Tribunal de commerce de Nimes, même en cas de pluralité de défendeurs ou d’appel en garantie.</p>
        </Card>
      </section>
    </div>
  );
}
